import { Select } from "@majitap/ui/arc/select/select";
import { useQuery } from "@tanstack/react-query";
import { partnerOptionsQuery } from "../../partners";

const OWN = "own";

/** Whose a truck, assistant, fill site or driver is (P8-42): the API's partner id, or null for the company's own. */
export type OwnerChoice = string | null;

/** "Own fleet" or the partner's name, as the lists and drawers show it. */
export const ownerName = (asset: { partner: { name: string } | null }) => asset.partner?.name ?? "Own fleet";

/**
 * Pick whose an asset is: the company's own or a partner's (P8-42). Moving one that is on an
 * open shift or an unfinished delivery is refused by the API (ASSET_ON_SHIFT, ASSET_ON_DELIVERY).
 */
export function OwnerSelect({
  value,
  onChange,
  description = "A partner's assets are dispatched with its drivers, and it is paid for their work.",
}: {
  value: OwnerChoice;
  onChange: (owner: OwnerChoice) => void;
  description?: string;
}) {
  const partners = useQuery(partnerOptionsQuery);
  return (
    <Select
      label="Owner"
      value={value ?? OWN}
      onValueChange={(v) => onChange(v === OWN ? null : v)}
      options={[{ value: OWN, label: "Own fleet" }, ...(partners.data ?? [])]}
      description={description}
    />
  );
}
